import { isNoEmptyArray, isNullOrUndefined, isValidString } from "@pineapplelab/util";
import { TemplateRef } from "@angular/core";

export class Table<T> {

  columns: Table.IColumn[] = [];
  selectable: boolean = false;
  type: 'checkbox' | 'toggle' | 'draggable' | 'none' = 'none';
  actions: boolean = false;
  deleteBtn: boolean = false;

  constructor(object: Table.ITable<T>) {
    if (!isNoEmptyArray(object.columns)) {
      throw new Error("You must set at least one column!");
    }
    object.columns = object.columns.map(column => isValidString(column) ? { field: column, label: column } : column) as Table.IColumn[];
    this.columns = object.columns as Table.IColumn[];
    this.selectable = object.selectable || false;
    this.type = object.type || 'checkbox';
    this.actions = object.actions || false;
    this.deleteBtn = object.deleteBtn;
  }
}

export namespace Table {
  export interface ITable<T> {
    columns: (Table.IColumn | string)[];
    selectable?: boolean;
    type?: 'checkbox' | 'toggle' | 'draggable' | 'none';
    actions?: boolean;
    deleteBtn?: boolean;
	disabledToggleCondition?: (element: T | any) => boolean;
  }
  export interface IColumn {
    field: string;
    label: string;
    template?: TemplateRef<any>;
    headerTemplate?: TemplateRef<any>;
    showOnlyTemplate?: boolean;
    hideColumnLabel?: boolean;
    showTooltip?: boolean;
    showTooltipAfter?: number;
	  disableColumnCondition?: (element: any) => boolean;
  }
}
